import PropTypes from 'prop-types';
import { useState } from 'react';
import { Box, Chip, CircularProgress, IconButton, Menu, MenuItem } from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { enqueueSnackbar } from 'notistack';
import { ClockIcon } from '@mui/x-date-pickers';
import axiosInstance from '../../../../utils/axios';
import { objectToFormData } from '../../../../api/utils';

FacilityManagerChips.propTypes = {
  row: PropTypes.object,
  facilityManagers: PropTypes.array,
  setRowData: PropTypes.func,
  getUpdateExistingManagedItems: PropTypes.func,
};

export default function FacilityManagerChips({ row, facilityManagers, setRowData, getUpdateExistingManagedItems }) {
  const [submitting, setSubmitting] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);

  const closeMenu = () => { setAnchorEl(null); setOpenMenu(false); };
  const getSubmitSingleData = (userId) => objectToFormData({ facilityId: row.facilityId, categoryId: row.categoryId, typeId: row.typeId, userId, updateExistingManagedItems: getUpdateExistingManagedItems() });

  const deleteManager = (userId) => {
    setSubmitting(true);
    axiosInstance.post("Admin/Facility/DeleteManager", getSubmitSingleData(userId))
      .then((res) => {
        if (res.data !== null) {
          setRowData(rows => rows.map(rowData => rowData.id !== row.id ? rowData : { ...rowData, managers: facilityManagers.filter(man => res.data.includes(man.userId)) }));
          enqueueSnackbar("Deleted manager", { variant: "success" })
        }
        else enqueueSnackbar("Delete manager failed", { variant: "error" })
      })
      .catch(() => enqueueSnackbar("Delete manager failed", { variant: "error" }))
      .finally(() => setSubmitting(false))
  }

  const addManager = (userId) => {
    setSubmitting(true);
    axiosInstance.post("Admin/Facility/AddManager", getSubmitSingleData(userId))
      .then((res) => {
        if (res.data !== null) {
          setRowData(rows => rows.map(rowData => rowData.id !== row.id ? rowData : { ...rowData, managers: facilityManagers.filter(man => res.data.includes(man.userId)) }));
          enqueueSnackbar("Added manager", { variant: "success" })
        }
        else enqueueSnackbar("Add manager failed", { variant: "error" })
      })
      .catch(() => enqueueSnackbar("Add manager failed", { variant: "error" }))
      .finally(() => { setSubmitting(false); closeMenu(); });
  }

  return submitting ? <CircularProgress size={20} /> :
    <Box sx={{ py: .5, mr: 0 }}>
      {!row.managers?.length ? "No Manager" : row.managers.map((manager, index) => <Chip
        key={index}
        label={manager.name}
        variant="filled"
        onDelete={() => deleteManager(manager.userId)}
        color='info'
        sx={{ border: `solid 1px` }}
        size="small"
      />)}
      <IconButton onClick={(e) => { setAnchorEl(e.currentTarget); setOpenMenu(true) }} size="small">
        <AddCircleOutline color={'primary'} width={20} height={20} />
      </IconButton>
      {openMenu && <Menu anchorEl={anchorEl} open={openMenu} sx={{ height: 300 }} onClose={closeMenu}>
        {(!facilityManagers || facilityManagers.length === 0) ? <MenuItem onClick={closeMenu}>No Managers</MenuItem>
          : facilityManagers.sort((a, b) => a.lastSelected !== b.lastSelected ? b.lastSelected - a.lastSelected : (a.name ?? "").localeCompare(b.name))
            .map((manager, index) => <MenuItem key={index} disabled={row.managers && row.managers.some(man => man.userId === manager.userId)}
              onClick={() => {
                manager.lastSelected = Math.max(...facilityManagers.map(man => man.lastSelected)) + 1;
                const selectedManagers = facilityManagers.filter(man => man.lastSelected > 0);
                if (selectedManagers.length > 3) {
                  const oldLastSelected = Math.min(...selectedManagers.map(man => man.lastSelected));
                  selectedManagers.find(man => man.lastSelected === oldLastSelected).lastSelected = 0;
                }
                addManager(manager.userId);
              }} >
              {manager.name} {manager.lastSelected > 0 && <ClockIcon sx={{ fontSize: 10, alignSelf: "top" }} color="secondary" />}
            </MenuItem>)}
      </Menu>}
    </Box>;
}